enum ACTION_TYPE {
    REQUEST_APPS = '@@REQUEST_APPS',
    REQUEST_APPS_PENDING = '@@REQUEST_APPS_PENDING',
    REQUEST_APPS_FULFILLED = '@@REQUEST_APPS_FULFILLED',
    REQUEST_APPS_REJECTED = '@@REQUEST_APPS_REJECTED',

    REQUEST_COEDIT_POLICY = '@@REQUEST_COEDIT_POLICY',
    UPDATE_COEDIT_POLICY = '@@UPDATE_COEDIT_POLICY',
    UPDATE_COEDIT_POLICY_FULFILLED = '@@UPDATE_COEDIT_POLICY_FULFILLED',
    UPDATE_COEDIT_POLICY_REJECTED = '@@UPDATE_COEDIT_POLICY_REJECTED',

    REQUEST_EDITORS = '@@REQUEST_EDITORS',
    REQUEST_EDITORS_PENDING = '@@REQUEST_EDITORS_PENDING',
    REQUEST_EDITORS_FULFILLED = '@@REQUEST_EDITORS_FULFILLED',
    REQUEST_EDITORS_REJECTED = '@@REQUEST_EDITORS_REJECTED',

    REQUEST_EDITORS_FAKE_PROTECT_SESSION = '@@REQUEST_EDITORS_FAKE_PROTECT_SESSION',

    APP_SETTINGS_CHANGED = '@@APP_SETTINGS_CHANGED',
    APP_SETTINGS_CHANGED_FULFILLED = '@@APP_SETTINGS_CHANGED_FULFILLED',
    APP_SETTINGS_CHANGED_REJECTED = '@@APP_SETTINGS_CHANGED_REJECTED',

    UPDATE_TRANSITION = '@@UPDATE_TRANSITION',
    UPDATE_SELECTED_GROUPS = '@@UPDATE_SELECTED_GROUPS',
    UPDATE_IS_DEFAULT_EDITOR = '@@UPDATE_IS_DEFAULT_EDITOR',
    UPDATE_COLLABORATION_APPS_HIERARCHY = '@@UPDATE_COLLABORATION_APPS_HIERARCHY',

    UPDATE_EDITORS_ORDER = '@@UPDATE_EDITORS_ORDER',
    SAVE_NEW_COLLABORATION_APPS_HIERARCHY = '@@SAVE_NEW_COLLABORATION_APPS_HIERARCHY',
    SAVE_NEW_COLLABORATION_APPS_HIERARCHY_FULFILLED = '@@SAVE_NEW_COLLABORATION_APPS_HIERARCHY_FULFILLED',
    SAVE_NEW_COLLABORATION_APPS_HIERARCHY_REJECTED = '@@SAVE_NEW_COLLABORATION_APPS_HIERARCHY_REJECTED',

    REQUEST_APP = '@@REQUEST_APP',
    REQUEST_APP_PENDING = '@@REQUEST_APP_PENDING',
    REQUEST_APP_FULFILLED = '@@REQUEST_APP_FULFILLED',
    REQUEST_APP_REJECTED = '@@REQUEST_APP_REJECTED',

    REQUEST_USER = '@@REQUEST_USER',
    REQUEST_USER_FULFILLED = '@@REQUEST_USER_FULFILLED',
    REQUEST_USER_REJECTED = '@@REQUEST_USER_REJECTED',

    TOGGLE_ADMIN_MODE = '@@TOGGLE_ADMIN_MODE',

    REQUEST_USER_SETTINGS_TOKEN = '@@REQUEST_USER_SETTINGS_TOKEN',
    REQUEST_USER_SETTINGS_TOKEN_PENDING = '@@REQUEST_USER_SETTINGS_TOKEN_PENDING',
    REQUEST_USER_SETTINGS_TOKEN_FULFILLED = '@@REQUEST_USER_SETTINGS_TOKEN_FULFILLED',
    REQUEST_USER_SETTINGS_TOKEN_REJECTED = '@@REQUEST_USER_SETTINGS_TOKEN_REJECTED',

    REQUEST_DOMAIN_SETTINGS_TOKEN = '@@REQUEST_DOMAIN_SETTINGS_TOKEN',
    REQUEST_DOMAIN_SETTINGS_TOKEN_PENDING = '@@REQUEST_DOMAIN_SETTINGS_TOKEN_PENDING',
    REQUEST_DOMAIN_SETTINGS_TOKEN_FULFILLED = '@@REQUEST_DOMAIN_SETTINGS_TOKEN_FULFILLED',
    REQUEST_DOMAIN_SETTINGS_TOKEN_REJECTED = '@@REQUEST_DOMAIN_SETTINGS_TOKEN_REJECTED',

    OPEN_SETTINGS_INFO_POPUP = '@@OPEN_SETTINGS_INFO_POPUP',
    CLOSE_SETTINGS_INFO_POPUP = '@@CLOSE_SETTINGS_INFO_POPUP',

    OPEN_REMOVE = '@@OPEN_REMOVE',
    CLOSE_REMOVE = '@@CLOSE_REMOVE',

    REQUEST_STATUS_FORM = '@@REQUEST_STATUS_FORM',
    REQUEST_STATUS_FORM_FULFILLED = '@@REQUEST_STATUS_FORM_FULFILLED',
    REQUEST_STATUS_FORM_PENDING = '@@REQUEST_STATUS_FORM_PENDING',
    REQUEST_STATUS_FORM_REJECTED = '@@REQUEST_STATUS_FORM_REJECTED',
    CLOSE_STATUS_FORM = '@@CLOSE_STATUS_FORM',

    OPEN_CONTROL_CENTER = '@@OPEN_CONTROL_CENTER',

    REQUEST_SEARCH_GROUPS = '@@REQUEST_SEARCH_GROUPS',
    REQUEST_SEARCH_GROUPS_PENDING = '@@REQUEST_SEARCH_GROUPS_PENDING',
    REQUEST_SEARCH_GROUPS_FULFILLED = '@@REQUEST_SEARCH_GROUPS_FULFILLED',
    REQUEST_SEARCH_GROUPS_REJECTED = '@@REQUEST_SEARCH_GROUPS_REJECTED',

    REQUEST_GET_ADDED_GROUPS = '@@REQUEST_GET_ADDED_GROUPS',
    REQUEST_GET_ADDED_GROUPS_PENDING = '@@REQUEST_GET_ADDED_GROUPS_PENDING',
    REQUEST_GET_ADDED_GROUPS_FULFILLED = '@@REQUEST_GET_ADDED_GROUPS_FULFILLED',
    REQUEST_GET_ADDED_GROUPS_REJECTED = '@@REQUEST_GET_ADDED_GROUPS_REJECTED',

    OPEN_URL = '@@OPEN_URL',
    CLOSE_URL = '@@CLOSE_URL',

    OPEN_SUGGESTION = '@@OPEN_SUGGESTION',
    CLOSE_SUGGESTION = '@@CLOSE_SUGGESTION',

    SUGGEST_APP = '@@SUGGEST_APP',
    SUGGEST_APP_PENDING = '@@SUGGEST_APP_PENDING',
    SUGGEST_APP_FULFILLED = '@@SUGGEST_APP_FULFILLED',
    SUGGEST_APP_REJECTED = '@@SUGGEST_APP_REJECTED',

    UPDATE_APPS_FILTER = '@@UPDATE_APPS_FILTER',
    REPLACE_APPS_FILTER = '@@REPLACE_APPS_FILTER',
    SELECT_NEW_FILTER = '@@SELECT_NEW_FILTER',
    RESET_APPS_FILTERS = '@@RESET_APPS_FILTERS',
    REFRESH_APPS_FILTER = '@@REFRESH_APPS_FILTER',

    TOGGLE_APPS_FILTERS = '@@TOGGLE_APPS_FILTERS',

    SEARCH_CHANGE = '@@SEARCH_CHANGE',

    HIDE_NOTIFICATION = '@@HIDE_NOTIFICATION',
    DESTROY_NOTIFICATION = '@@DESTROY_NOTIFICATION',

    CLICK_LINK = '@@CLICK_LINK',
    COPY_PERMALINK = '@@COPY_PERMALINK',

    SUBMIT_FEEDBACK = '@@SUBMIT_FEEDBACK',
    SUBMIT_FEEDBACK_PENDING = '@@SUBMIT_FEEDBACK_PENDING',
    SUBMIT_FEEDBACK_FULFILLED = '@@SUBMIT_FEEDBACK_FULFILLED',
    SUBMIT_FEEDBACK_REJECTED = '@@SUBMIT_FEEDBACK_REJECTED',

    PLATFORM_SELECT = '@@PLATFORM_SELECT',

    TRACK = '@@TRACK',

    ADD_SIDELOADED_APP = '@@ADD_SIDELOADED_APP',
    ADD_SIDELOADED_APP_PENDING = '@@ADD_SIDELOADED_APP_PENDING',
    ADD_SIDELOADED_APP_FULFILLED = '@@ADD_SIDELOADED_APP_FULFILLED',
    ADD_SIDELOADED_APP_REJECTED = '@@ADD_SIDELOADED_APP_REJECTED',
    CLOSE_SIDELOADED_APP_MODAL = '@@CLOSE_SIDELOADED_APP_MODAL',
    OPEN_SIDELOADED_APP_MODAL = '@@OPEN_SIDELOADED_APP_MODAL',
    LOAD_APP_DEFINITION = '@@LOAD_APP_DEFINITION',

    REUPLOAD_SIDELOADED_APP = '@@REUPLOAD_SIDELOADED_APP',
    REUPLOAD_SIDELOADED_APP_PENDING = '@@REUPLOAD_SIDELOADED_APP_PENDING',
    REUPLOAD_SIDELOADED_APP_FULFILLED = '@@REUPLOAD_SIDELOADED_APP_FULFILLED',
    REUPLOAD_SIDELOADED_APP_REJECTED = '@@REUPLOAD_SIDELOADED_APP_REJECTED',
    CLOSE_SIDELOADED_APP_CONFIGURATION_MODAL = '@@CLOSE_SIDELOADED_CONFIGURATION_APP_MODAL',
    OPEN_SIDELOADED_APP_CONFIGURATION_MODAL = '@@OPEN_SIDELOADED_CONFIGURATION_APP_MODAL',
    REMOVE_SIDELOADED_APP = '@@REMOVE_SIDELOADED_APP',
    REMOVE_SIDELOADED_APP_PENDING = '@@REMOVE_SIDELOADED_APP_PENDING',
    REMOVE_SIDELOADED_APP_FULFILLED = '@@REMOVE_SIDELOADED_APP_FULFILLED',
    REMOVE_SIDELOADED_APP_REJECTED = '@@REMOVE_SIDELOADED_APP_REJECTED',
    RELOAD_APP_DEFINITION = '@@RELOAD_APP_DEFINITION',
    SHOW_REMOVE_SIDELOADED_APP_CONFIRMATION_MODAL = '@@SHOW_REMOVE_SIDELOADED_APP_CONFIRMATION_MODAL',

    SUGGEST_SETTING_DEFAULT_APP = '@@SUGGEST_SETTING_DEFAULT_APP',

    SET_STATE_QUERY_PARAM_PLATFORM = `@@SET_STATE_QUERY_PARAM_PLATFORM`,

    UPDATE_CUSTOM_DATA = `@@UPDATE_CUSTOM_DATA`,
    UPDATE_CUSTOM_DATA_FULFILLED = `@@UPDATE_CUSTOM_DATA_FULFILLED`,
    UPDATE_CUSTOM_DATA_REJECTED = `@@UPDATE_CUSTOM_DATA_REJECTED`,
}

export default ACTION_TYPE;
